import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';

import NatureType from './NatureType';
import OwnerType from './OwnerType';
import CategoryType from './CategoryType';
import TransactionKeyTag from './TransactionKeyTag';
import ShowAllTableButton from "./ShowAllTableButton";



const TransactionKeyList = ({calculateToDate, data}) => {
  const [showAll, setShowAll] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {    
    let newList = [];
    if (data){
      for(let i = 0; i < data.transactionKeyTable.length; i++){
        let item = data.transactionKeyTable[i];
        item.isUsed = false;
        if (showAll){
          newList.push(item);
        }else{
          item.isUsed = isTransactionKeyUsed(i, data.transactionKeyTable);
          if (item.isUsed){
            newList.push(item);
          }
        }        
      }
    }  
    setDataList(newList);  
  },[showAll]);

  const showTableClick = (showAll) => {
    setShowAll(!showAll);    
  };


  const isTransactionKeyUsed = (itemNumber, list) => {
    let item = list[itemNumber];

    let defaultKeys = ["000000", "101000", "102000", "102100", "110000" ];

    //check for payments
    for(let i = 0; i < data.payments.length; i++){
      let payment = data.payments[i];
      if (item.key === payment.transactionKey.key){
        return true;
      }
    }
    //check for cost
    for(let i = 0; i < data.costs.length; i++){
      let cost = data.costs[i];
      if (item.key === cost.transactionKey.key){
        return true;
      }
    }
    //check for returns
    for(let i = 0; i < data.returns.length; i++){
      let returnItem = data.returns[i];
      if (item.key === returnItem.transactionKey.key){
        return true;
      }
    }
    //defaultkeys
    for(let i = 0; i < defaultKeys.length; i++){
      if (item.key === defaultKeys[i]){
        return true;
      }
    }
    //some extra skil
    if (item.key.startsWith("9998")){
      return true;
    }

    return false;
  };

  if (!dataList){
    return (
      <div/>
    );
  }
    
  return (
    <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="8" className="text-left calc-setting-table-header">Færslulyklar</th>
          <th className="text-right"><ShowAllTableButton showAll={showAll} handleShowHideClick={showTableClick}/></th>
        </tr>
        <tr>
          <th className="text-left">Lykill</th>
          <th className="text-left">Heiti</th>
          <th className="text-left">Eigandi</th>
          <th className="text-left">Tegund</th>
          <th className="text-left">Eðli</th>
          <th className="text-left">VSK</th>
          <th className="text-left">Vextir</th>
          <th className="text-left">Hópur</th>
          <th className="text-left">Heiti hóps</th>
        </tr>
        </thead>
        <tbody>
        {dataList.map((item,i) => {
          let vatContent;
          let interestContent;
          if (item.calculateVat){
            vatContent = (
              <TransactionKeyTag color={'#ff00ff'} type={'V'} description={'VSK'}/>
            );
          }
          if (item.calculateInterest){
            interestContent = (
              <TransactionKeyTag color={'#ff0000'} type={'D'} description={'Dráttavextir'}/>
            );
          }

          let shouldHighlightClass = ((item.isUsed && showAll) ? "calc-setting-table-highlight" : "" );

          return(
            <tr className={shouldHighlightClass} key={i}>
              <td className="text-left">{item.key}</td>
              <td className="text-left">{item.name}</td>
              <td className="text-left"><OwnerType data={item.ownerType}/></td>
              <td className="text-left"><CategoryType data={item.categoryType}/></td>
              <td className="text-left"><NatureType data={item.natureType}/></td>
              <td className="text-left">{vatContent}</td>
              <td className="text-left">{interestContent}</td>
              <td className="text-left">{item.transactionGroup.groupKey}</td>
              <td className="text-left">{item.transactionGroup.name}</td>
            </tr>);
        })}
        </tbody>
      </table>        
    </div>
  );  
}


// class TransactionKeyList extends React.Component {

//   state = {
//     showAll : false,
//     calculateToDate : this.props.calculateToDate
//   };

//   constructor(props){
//     super(props);
//     this.showTableClick = this.showTableClick.bind(this);
//   }

//   componentWillReceiveProps(nextProps) {
//     this.setState({ calculateToDate: nextProps.calculateToDate });
//   }

//   showTableClick(showAll){
//     this.setState({ showAll: showAll });
//   };


//   isTransactionKeyUsed(itemNumber, list){
//     let item = list[itemNumber];

//     let defaultKeys = ["000000", "101000", "102000", "102100", "110000" ];

//     //check for payments
//     for(let i = 0; i < this.props.data.payments.length; i++){
//       let payment = this.props.data.payments[i];
//       if (item.key === payment.transactionKey.key){
//         return true;
//       }
//     }
//     //check for cost
//     for(let i = 0; i < this.props.data.costs.length; i++){
//       let cost = this.props.data.costs[i];
//       if (item.key === cost.transactionKey.key){
//         return true;
//       }
//     }
//     //check for returns
//     for(let i = 0; i < this.props.data.returns.length; i++){
//       let returnItem = this.props.data.returns[i];
//       if (item.key === returnItem.transactionKey.key){
//         return true;
//       }
//     }
//     //defaultkeys
//     for(let i = 0; i < defaultKeys.length; i++){
//       if (item.key === defaultKeys[i]){
//         return true;
//       }
//     }
//     //some extra skil
//     if (item.key.startsWith("9998")){
//       return true;
//     }

//     return false;
//   };


//   render() {

//     if (!this.props.data.transactionKeyTable){
//       return (
//         <div/>
//       );
//     }

//     let transKeys = this.props.data.transactionKeyTable;
//     return (
//       <div className="calc-setting-table">
//         <table className="table">
//           <colgroup>
//             <col />
//             <col />
//             <col />
//           </colgroup>
//           <thead>
//           <tr>
//             <th colSpan="8" className="text-left calc-setting-table-header">Færslulyklar</th>
//             <th className="text-right"><ShowAllTableButton showAll={this.state.showAll} handleShowHideClick={this.showTableClick}/></th>
//           </tr>
//           <tr>
//             <th className="text-left">Lykill</th>
//             <th className="text-left">Heiti</th>
//             <th className="text-left">Eigandi</th>
//             <th className="text-left">Tegund</th>
//             <th className="text-left">Eðli</th>
//             <th className="text-left">VSK</th>
//             <th className="text-left">Vextir</th>
//             <th className="text-left">Hópur</th>
//             <th className="text-left">Heiti hóps</th>
//           </tr>
//           </thead>
//           <tbody>
//           {transKeys.map((item,i) => {
//             let isUsed = this.isTransactionKeyUsed(i, transKeys);
//             if ((!isUsed) && (!this.state.showAll)) {
//               return null;
//             }

//             let vatContent;
//             let interestContent;
//             if (item.calculateVat){
//               vatContent = (
//                 <TransactionKeyTag color={'#ff00ff'} type={'V'} description={'VSK'}/>
//               );
//             }
//             if (item.calculateInterest){
//               interestContent = (
//                 <TransactionKeyTag color={'#ff0000'} type={'D'} description={'Dráttavextir'}/>
//               );
//             }

//             let shouldHighlightClass = ((isUsed && this.state.showAll) ? "calc-setting-table-highlight" : "" );

//             return(
//               <tr className={shouldHighlightClass} key={i}>
//                 <td className="text-left">{item.key}</td>
//                 <td className="text-left">{item.name}</td>
//                 <td className="text-left"><OwnerType data={item.ownerType}/></td>
//                 <td className="text-left"><CategoryType data={item.categoryType}/></td>
//                 <td className="text-left"><NatureType data={item.natureType}/></td>
//                 <td className="text-left">{vatContent}</td>
//                 <td className="text-left">{interestContent}</td>
//                 <td className="text-left">{item.transactionGroup.groupKey}</td>
//                 <td className="text-left">{item.transactionGroup.name}</td>
//               </tr>);
//           })}
//           </tbody>
//         </table>        
//       </div>
//     );
//   }
// }

TransactionKeyList.propTypes = {
    data: PropTypes.object,
    calculateToDate: PropTypes.object
};



export default TransactionKeyList;
